import * as React from "react"
import {
  type Transaction,
  useReadBooksClosedDateQuery,
} from "@digits-graphql/frontend/graphql-bearer"
import useSession from "@digits-shared/hooks/useSession"
import type FrontendSession from "src/frontend/session"

export function useHasTransactionsInClosedPeriod(transactions: Transaction[]) {
  const { currentLegalEntityId } = useSession<FrontendSession>()
  const { data } = useReadBooksClosedDateQuery({
    variables: {
      legalEntityId: currentLegalEntityId,
    },
  })

  const closedTimestamp = React.useMemo(
    () => data?.readBooksClosedDate.latestBooksClosedDateFact,
    [data]
  )

  return React.useMemo(
    () =>
      closedTimestamp
        ? transactions.some((transaction) => transaction.timestamp <= closedTimestamp)
        : false,
    [closedTimestamp, transactions]
  )
}
